import { useState } from 'react';
import { Trans } from 'react-i18next';
import {
    Button,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    ListItemText,
    MenuItem,
} from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid'

import RoleChipSelect from './RoleChipSelect';

function EditUserRolesActionItem({ onSubmit, userId, roles, allRoles, ...props }) {
    const [open, setOpen] = useState(false);
    const [updatedRoles, setUpdatedRoles] = useState(roles.map(r => r.name))

    const handleSelectChange = (e) => {
        setUpdatedRoles(e.target.value)
    }

    return (
        <>
            <GridActionsCellItem {...props} onClick={() => setOpen(true)} />
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
            >
                <DialogTitle id="alert-dialog-title"> <Trans i18nKey='benutzerrollenAktualisieren' ns='editUserRolesActionItem'>Benutzerrollen aktualisieren</Trans> </DialogTitle>
                <DialogContent>
                    <RoleChipSelect
                        value={updatedRoles}
                        onChange={handleSelectChange}
                    >
                        {allRoles.map((role) => (
                            <MenuItem key={role.name} value={role.name}>
                                <Checkbox checked={updatedRoles.indexOf(role.name) >= 0} />
                                <ListItemText primary={role.name} />
                            </MenuItem>
                        ))}
                    </RoleChipSelect>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setOpen(false);
                            setUpdatedRoles(roles.map(r => r.name))
                        }}
                        color="warning"
                        autoFocus
                    >
                        <Trans i18nKey='abbrechen' ns='common'>Abbrechen</Trans>
                    </Button>
                    <Button onClick={() => {
                        setOpen(false)
                        onSubmit(userId, allRoles.filter(r => updatedRoles.indexOf(r.name) >= 0))

                    }}><Trans i18nKey='speichern' ns='common'>Speichern</Trans></Button>

                </DialogActions>
            </Dialog>
        </>
    )
}

export default EditUserRolesActionItem
